import React from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

import CardOfUser from '../CardOfUser';

import { useModal } from '../Modal/ModalContext';
import { useTimeModal } from '../TimeModal/TimeModalContext';

import Loading from '../Loading';

import styles from '../../styles/DynamicModal.module.css';

const WorkerCase = ({ caseId, workerId, statusCase, onAppointWorkerForCaseSuccess }) => {
    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();

    const [userRole, setUserRole] = React.useState('');
    const [userId, setUserId] = React.useState(null);
    const [worker, setWorker] = React.useState([]);
    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);

    const [isCardOfUser, setIsCardOfUser] = React.useState(false);
    const [currentAMId, setCurrentAMId] = React.useState('');
    
    React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
        const decodedToken = jwtDecode(token);
        setUserRole(decodedToken.role);
    }
    }, []);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        setLoading(true);
        axios.get(`/api/user`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setUserId(response.data.id);
        })
        .catch(error => {
            console.log(error);
            openTimeModal(`Ошибка загрузки компонента: ${error.response?.data.message || error.message}`, 'error');
        })
        .finally(() => {
            setLoading(false);
        })
    }, [caseId, reload])

    React.useEffect(() => {
        if (!workerId) return;
        const token = localStorage.getItem('token');
        setLoading(true);
        axios.get(`/api/get-minimum-info-user?id=${workerId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setWorker(response.data);
        })
        .catch(error => {
            openTimeModal(`Ошибка загрузки компонента: ${error.response?.data.message || error.message}`, 'error');
        })
        .finally(() => {
            setLoading(false);
        })
    }, [workerId])

    const workerAppointment = () => {
        const token = localStorage.getItem('token');
        setLoading(true);
        axios.put(`/api/appoint-a-worker-on-a-case?userId=${userId}&caseId=${caseId}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            if (response.data == '') {
                openTimeModal('Теперь карточка закреплена за вами', 'success');
            } else {
                if (response.data == userId) {
                    openTimeModal('Вы успешно откреплены', 'success');
                } else {
                    openTimeModal('Работник успешно откреплён', 'success');
                }
            }
            if (onAppointWorkerForCaseSuccess) {onAppointWorkerForCaseSuccess()};
        })
        .catch(error => {
            openTimeModal(`Ошибка: ${error.response?.data.message || error.message}`, 'error');
        })
        .finally(() => {
            setLoading(false);
        })
    }

    return (
        <>
            {isCardOfUser && <CardOfUser closeModal={() => {setIsCardOfUser(false)}} id={currentAMId} onCardOfAMSuccess={() => {setReload(true);}} />}

            {loading ? <Loading />
            : <div className={styles.outliningPanel}>
                {workerId===null ? 
                <>
                    <a>На данный момент карточка не закреплена за работником СОАУ.</a>
                    <button type='button' className='button black' onClick={() => {workerAppointment()}}>Начать ведение</button>
                </>
                : 
                <>
                    <a onClick={() => {setIsCardOfUser(true); setCurrentAMId(workerId);}} style={{cursor: 'pointer'}}>{worker.lastname} {worker.firstname} {worker.surname}</a>
                    <a href={`mailto:${worker.email}`} className={styles.aWithLink}>{worker.email}</a>
                    {statusCase!=='Завершено' && (userRole=='Администратор' || userRole=='Менеджер' || userId==workerId ? 
                    (
                        <button type='button' className='miniButton' style={{margin: '7px 0 0 0'}} onClick={() => {workerAppointment()}}>Прекратить ведение</button>
                    )
                    :
                    (<></>)
                    )}
                </>}
            </div>}
        </>
    )
}

export default WorkerCase;